import React, { useState } from 'react';
import NewShopnshipTrackingModal from './modals/new-shopnship-tracking-modal';
import NewTrackingModal from './modals/new-tracking-modal';
import SubmitButton from './submit-button';
import NewFrozenFoodTrackingModal from './modals/new-frozen-food-tracking-modal';

// import {
//   CompletedIcon,
//   ProgressIcon,
//   SelectArrowBlue
// } from '../../constants/asset-contants';

const TrackingOptions = () => {
  const [shipmentType, setShipmentType] = useState('');
  const [selectedTracking, setSelectedTracking] = useState('');
  const [showPrompt, setShowPrompt] = useState(true);
  const [openModal, setOpenModal] = useState(true);

  const handleSubmit = e => {
    e.preventDefault();
    setShowPrompt(false);
    setSelectedTracking(shipmentType);
  };

  const goBack = () => {
    setSelectedTracking('');
    setShipmentType('');
    setShowPrompt(true);
    setOpenModal(true);
  };

  return (
    <div
      className={`Year__roundup-container fade show`}
      style={{
        transition: 'all 0.3s ease',
        justifyContent: showPrompt ? 'center' : 'flex-start',
        background: selectedTracking ? 'none' : '',
        backdropFilter: 'none'
      }}
    >
      {showPrompt && (
        <div
          className='new-tracking__modal__wrap noData'
          style={{ background: 'white' }}
        >
          <div
            className='new-tracking__modal__header'
            style={{
              justifyContent: 'space-between'
            }}
          >
            <h2>Select Shipment Type</h2>
            {/* <IconButton onClick={exitModal}>
            <Close />
          </IconButton> */}
          </div>
          <div className='new-tracking__modal__body'>
            <form
              onSubmit={e => handleSubmit(e)}
              className='new-tracking__modal__body__wrap'
            >
              <select
                className='select__shipment-type'
                required
                value={shipmentType}
                onChange={e => setShipmentType(e.target.value)}
              >
                <option value=''>Select</option>
                <option value='shipment'>Shipment</option>
                <option value='shopnship'>Shop & Ship</option>
                <option value='frozen-food'>Frozen Food</option>
              </select>

              <SubmitButton
                text='Proceed'
                className='new-tracking__modal__button'
              />
            </form>
          </div>
        </div>
      )}
      {selectedTracking === 'shipment' && (
        <NewTrackingModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          goBack={goBack}
          isTrackingPage={true}
        />
      )}
      {selectedTracking === 'shopnship' && (
        <NewShopnshipTrackingModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          isTrackingPage={true}
          goBack={goBack}
        />
      )}
      {selectedTracking === 'frozen-food' && (
        <NewFrozenFoodTrackingModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          isTrackingPage={true}
          goBack={goBack}
        />
      )}
    </div>
  );
};

export default TrackingOptions;
